var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26547 2.03835L3.31153 7.99229L9.26547 13.9462C9.49109 14.1718 9.61784 14.4779 9.61784 14.7969C9.61784 15.116 9.49109 15.422 9.26547 15.6476C9.03985 15.8732 8.73384 16 8.41477 16C8.09569 16 7.78968 15.8732 7.56406 15.6476L0.760388 8.84299C0.64809 8.73161 0.558974 8.59909 0.49819 8.45308C0.437406 8.30706 0.406157 8.15045 0.40625 7.99229C0.40625 7.67376 0.533278 7.36677 0.758463 7.14159L7.5631 0.33791C7.78991 0.118725 8.09374 -0.00260861 8.40914 4.25492e-05C8.72454 0.00269371 9.02628 0.129117 9.24938 0.352085C9.47247 0.575052 9.59906 0.876722 9.60189 1.19212C9.60472 1.50752 9.48356 1.81141 9.2645 2.03835H9.26547Z",
    fill: "#2C2D3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.2179f81459de22aab2992a70708ce73b.svg";
export { ForwardRef as ReactComponent };